import {Route, Routes} from 'react-router-dom'
import LimpiezaPageWrapper from '../khipu/features/limpieza/pages/LimpiezaPageWrapper'

const LimpiezaRoutes = () => {
  return (
    <Routes>
      <Route index element={<LimpiezaPageWrapper />} />
    </Routes>
  )
}

export {LimpiezaRoutes}
